export default defineNuxtPlugin(async (nuxt) => {
	nuxt.vueApp.directive('select', {
		mounted(el) {
			if (document.selection) {
				// IE
				const range = document.body.createTextRange()
				range.moveToElementText(el)
				range.select()
			} else if (window.getSelection) {
				// all other browsers
				const range = document.createRange()
				range.selectNode(el)
				window.getSelection().removeAllRanges()
				window.getSelection().addRange(range)
			}
		},
	})
})
